import {naturalSort} from '@benchling/js-utils';
import _ from 'underscore';

import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as NavConstants from 'constants/NavConstants';
import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getDefaultSearchSearchParams} from 'nav/sidepanel/listing/SearchSearchParams';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import * as SidepanelReduxActions from 'nav/sidepanel/SidepanelReduxActions';
import ReviewConstants from 'notebook/reviews/ReviewConstants';
import {
  isDashboardTypeAssignable,
  SUPPORTED_DASHBOARD_TYPES_BY_PROCESS_CLIENT_ORIGIN,
} from 'processes/dashboard/ProcessManagementSidepanelConstants';
import {getEnabledClientOrigins} from 'processes/ProcessConstants';
import {getStore} from 'redux-stores/Store';
import {Filter, FilterKey, keyToEmptyFilter, Operator} from 'search/SearchConstants';
import * as SearchUtil from 'search/SearchUtil';
import isModelTypeEnabledForListing from 'util/isModelTypeEnabledForListing';

/** Opens global search for reviewables the current user authored (or audited). */
export function openMyWorkReviewableSearch(modelTypes: Array<ModelTypeConstants>): void {
  getStore().dispatch(
    SidepanelReduxActions.openListing(
      NavConstants.Section.SEARCH,
      SearchUtil.mergeFiltersToSearchParams(getDefaultSearchSearchParams(), [
        {
          ...keyToEmptyFilter(FilterKey.TYPES),
          value: modelTypes.filter((type) => isModelTypeEnabledForListing(type)),
        },
        {
          ...keyToEmptyFilter(FilterKey.REVIEW),
          value: {
            review_status: null,
            reviewerStatus: null,
            role: BenchlingConfig.ENABLE_CONSISTENT_REVIEW_SUMMARY_COUNT
              ? ReviewConstants.ROLE_FILTERS.AUTHOR
              : ReviewConstants.ROLE_FILTERS.AUTHOR_OR_AUDITOR,
          },
        },
      ])
    )
  );
}

/** Opens search or the processes dashboard for tasks assigned to the current user. */
export function openAllAssignedTasksSearch(): void {
  const enabledClientOrigins = getEnabledClientOrigins();

  const searchFilterTypes: Array<ModelTypeConstants> = [];
  for (const clientOrigin of enabledClientOrigins) {
    const supportedTypes = SUPPORTED_DASHBOARD_TYPES_BY_PROCESS_CLIENT_ORIGIN[clientOrigin];
    for (const supportedType of supportedTypes) {
      if (isDashboardTypeAssignable(supportedType)) {
        searchFilterTypes.push(supportedType);
      }
    }
  }

  const searchFilters: Array<Filter> = [
    {
      ...keyToEmptyFilter(FilterKey.TYPES),
      value: naturalSort(_.unique(searchFilterTypes)),
    },
    {
      ...keyToEmptyFilter(FilterKey.PROCESS_TASK_ASSIGNEE),
      value: null,
      operator: Operator.CURRENT_USER,
    },
  ];

  const navSectionToShow =
    enabledClientOrigins.length === 1 && enabledClientOrigins[0] === ProcessClientOrigin.PROCESSES
      ? NavConstants.Section.PROCESSES
      : NavConstants.Section.SEARCH;

  if (navSectionToShow === NavConstants.Section.PROCESSES) {
    searchFilters.push({
      ...keyToEmptyFilter(FilterKey.PROCESS_CLIENT_ORIGIN),
      value: ProcessClientOrigin.PROCESSES,
    });
  }

  getStore().dispatch(
    SidepanelReduxActions.openListing(
      navSectionToShow,
      SearchUtil.mergeFiltersToSearchParams(getDefaultSearchSearchParams(), searchFilters)
    )
  );
  SidepanelActions.expand();
}
